export default "__VITE_ASSET__DvFOjyhs__"